import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../@cultureamp/frontend-svg-util/browser-sprite.js";
var symbol = new SpriteSymbol({
  "id": "ca-icon-caution-white.icon",
  "use": "ca-icon-caution-white.icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"ca-icon-caution-white.icon\"><path d=\"M8.67 2.822 2.16 15.849A1.486 1.486 0 0 0 3.488 18h13.024a1.486 1.486 0 0 0 1.33-2.151L11.328 2.822c-.548-1.096-2.11-1.096-2.658 0Z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.8 15H9.2v-1.6h1.6V15Zm0-3.2H9.2V7h1.6v4.8Z\" fill=\"#FFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol